import script from "./FeatureCards.vue?vue&type=script&setup=true&lang=js"
export * from "./FeatureCards.vue?vue&type=script&setup=true&lang=js"

import "./FeatureCards.vue?vue&type=style&index=0&id=45a6aa13&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45a6aa13"]])

export default __exports__